<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('task.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('task.pageTitle'),
          href: '/admin/tasks'
        },
        {
          text: $t('update'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-items-center ts-space-x-3">
          <button v-if="isAllowBack" @click.prevent="$router.go(-1)"
            class=" ts-w-6 ts-h-6 ts-bg-red-600 ts-rounded-full ts-flex ts-items-center ts-justify-center focus:ts-outline-none">
            <Icon type="md-arrow-round-back" class="ts-text-white" size="20" />
          </button>
        </div>
        <div class="ts-p-2 ts-rounded-md">
          <div class="ts-grid ts-grid-cols-3 ts-gap-5">
            <div class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative">
              <Connector />
              <BasicInfo ref="basicinfo" v-model="model" :validate="errors"
                :resources="{ status, priority, projects, milestones }" />
            </div>
            <div class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative">
              <Connector />
              <DateForm v-model="model" :validate="errors" :resources="{ milestones, sites }"
                @add-project="addProjectFromChild" @add-milestone="addMilestoneFromChild" />
            </div>

            <div class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3">
              <Client v-model="model" :resources="{ sites }" />
            </div>
          </div>
          <div class="ts-grid ts-grid-cols-2 ts-gap-3">
            <AttachFile v-model="model" :validate="errors" />
            <div
              class="ts-mt-4 ts-border-2 ts-border-dashed ts ts-py-3 ts-px-5 ts-h-24 ts-rounded-md ts-space-x-1 ts-overflow-y-scroll">
              <view-attachment :resource="arrayFiles" />
            </div>
          </div>
        </div>
        <div class="row ts-mt-3">
          <div class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3">
            <ts-button @click.prevent="$router.go(-1)">
              {{ $t('cancel') }}</ts-button>
            <ts-button color="primary" @click.prevent="onUpdate">
              {{ $t('update') }}</ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import AttachFile from './components/attach-file.vue'
import ViewAttachment from './components/view-attachment.vue'
import Connector from './components/connector.vue'
import BasicInfo from './components/basic-info.vue'
import DateForm from './components/date-form.vue'
import Client from './components/client.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    AttachFile,
    Connector,
    BasicInfo,
    DateForm,
    Client,
    ViewAttachment
  },
  data() {
    return {
      errors: new Errors(),
      status: [],
      priority: [],
      owners: [],
      projects: [],
      milestones: [],
      sites: [],
      tasks: [],
      loading: false,
      arrayFiles: [],
      model: {
        title: '',
        status_id: 1,
        priority_id: '',
        owner_id: '',
        member: [],
        estimate_date: [],
        actual_date: [],
        project_id: '',
        milestone_id: '',
        site_profile_id: '',
        dependency_task_id: '',
        client_name: '',
        client_mobile_number: '',
        client_address: '',
        remarks: '',
        files: [],
        fee_amount: '',
        location_pin: {
          lat: '',
          lng: ''
        },
        start_location: {
          lat: '',
          lng: ''
        },
        end_location: {
          lat: '',
          lng: ''
        },
        start_name: '',
        end_name: '',
        estimate_qty: 0
      }
    }
  },
  computed: {
    isAllowBack() {
      return true
      return Object.keys(this.$route.query).length
    }
  },
  created() { },
  methods: {
    ...mapActions('projectMgt/taskProfile', [
      'formViewModel',
      'update',
      'find'
    ]),
    fetchRecordById(id) {
      this.loading = true
      this.find(id)
        .then(response => this.setData(response.data))
        .then(() =>
          this.formViewModel({
            fnName: 'status,priority,project,site,milestone'
          }).then(response => {
            this.status = response.data.status
            this.priority = response.data.priority
            this.projects = response.data.project
            this.sites = response.data.site
            this.milestones = response.data.milestone
          })
        )

        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onUpdate() {
      const data = this.serializeData()
      this.loading = true
      this.errors.clear()
      this.update({
        id: this.$route.params.id,
        data: data
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.go(-1)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    serializeData() {
      const formData = new FormData()
      const keys = Object.keys(this.model)

      keys.forEach(key => {
        if (key !== 'files') {
          if (Array.isArray(this.model[key])) {
            for (let n = 0; n <= this.model[key].length - 1; n++) {
              formData.append(key + `[${n}]`, this.model[key][n])
            }
          } else {
            formData.append(key, this.isObject(this.model[key]))
          }
        }

        if (key == 'files') {
          for (var i = 0; i < this.model.files.length; i++) {
            let file = this.model.files[i]

            formData.append('files[' + i + ']', file)
          }
        }
      })

      return formData
    },
    addProjectFromChild(project) {
      this.projects.push(project)
    },
    addMilestoneFromChild(milestone) {
      this.milestones.push(milestone)
    },
    setData(data) {
      if (data.project_id) {
        this.$refs.basicinfo.fetchModel()
      }
      this.model.title = data.title
      this.model.status_id = data.status_id
      this.model.priority_id = data.priority_id
      this.model.owner_id = data.owner_id
      this.model.member = data.member
        ? JSON.parse(data.member).map(el => el.user_id)
        : []
      if (data.estimate_start_date && data.estimate_end_date) {
        this.model.estimate_date = [
          data.estimate_start_date,
          data.estimate_end_date
        ]
      }
      if (data.actual_start_date && data.actual_end_date) {
        this.model.actual_date = [data.actual_start_date, data.actual_end_date]
      }

      this.model.project_id = data.project_id
      this.model.milestone_id = data.milestone_id
      this.model.site_profile_id = data.site_profile_id
      this.model.dependency_task_id = data.dependency_task_id
      this.model.client_name = data.client_name
      this.model.client_mobile_number = data.client_mobile_number
      this.model.client_address = data.client_address
      this.model.remarks = data.remarks
      this.model.fee_amount = data.fee_amount
      this.model.start_name = data.start_name
      this.model.end_name = data.end_name
      this.model.estimate_qty = data.estimate_qty
      this.model.files = []

      this.arrayFiles = { attachments: data.attachments }

      this.model.location_pin = data.location_pin
        ? JSON.parse(data.location_pin)
        : {
          lat: '',
          lng: ''
        }
      this.model.start_location = data.start_location
        ? JSON.parse(data.start_location)
        : {
          lat: '',
          lng: ''
        }
      this.model.end_location = data.end_location
        ? JSON.parse(data.end_location)
        : {
          lat: '',
          lng: ''
        }
    },
    isObject(value) {
      return typeof value === 'object' ? JSON.stringify(value) : value
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchRecordById(to.params.id)
    })
  }
}
</script>
